import { Drop, Flask, Scissors, PottedPlant, Bug, NotePencil, FirstAidKit, Camera, Lamp, SprayBottle, ArrowsClockwise, Broom, Shovel, Waves } from "@phosphor-icons/react";

export const CARE_TYPES = [
  { key: "watering", label: "Water", verb: "Watered", Icon: Drop },
  { key: "fertilizing", label: "Fertilize", verb: "Fed", Icon: Flask },
  { key: "pruning", label: "Prune", verb: "Pruned", Icon: Scissors },
  { key: "repotting", label: "Repot", verb: "Repotted", Icon: PottedPlant },
  { key: "pest_treatment", label: "Pest treat", verb: "Treated", Icon: Bug },
  { key: "grow_light", label: "Grow light", verb: "Grow light", Icon: Lamp },
  { key: "disease", label: "Disease", verb: "Noted", Icon: FirstAidKit },
  { key: "photo", label: "Photo", verb: "Photo", Icon: Camera },
  { key: "note", label: "Note", verb: "Noted", Icon: NotePencil },
];

export const BATCH_ACTIONS = [
  { key: "watering", label: "Water", verb: "watered", Icon: Drop },
  { key: "fertilizing", label: "Fertilize", verb: "fertilized", Icon: Flask },
  { key: "pruning", label: "Prune", verb: "pruned", Icon: Scissors },
  { key: "repotting", label: "Repot", verb: "repotted", Icon: PottedPlant },
  { key: "pest_treatment", label: "Pest treat", verb: "treated", Icon: Bug },
  { key: "grow_light", label: "Grow light", verb: "updated", Icon: Lamp },
  { key: "note", label: "Inspect / note", verb: "noted", Icon: NotePencil },
];

export const BATCH_EXTRAS = [
  { key: "disease", label: "Disease", event: "disease", Icon: FirstAidKit, color: "#FF453A" },
  { key: "mist", label: "Mist", Icon: SprayBottle, color: "#0E86C2" },
  { key: "rotate", label: "Rotate", Icon: ArrowsClockwise, color: "#B86200" },
  { key: "clean_leaves", label: "Clean leaves", Icon: Broom, color: "#23899C" },
  { key: "soil_check", label: "Check soil", Icon: Shovel, color: "#8F6E47" },
  { key: "flush", label: "Flush soil", Icon: Waves, color: "#0A6FD6" },
];
